import {
  createContext,
  type PropsWithChildren,
  type ReactElement,
  useContext,
} from 'react';

type Actions<T> = (
  series: T,
  ...rest: unknown[]
) => ReactElement<PropsWithChildren>;
interface ChartSeriesActionContextProps {
  chartSeriesActions?: Actions<unknown>;
}

export const ChartSeriesActionContext =
  createContext<ChartSeriesActionContextProps>({});

export const useSeriesActions = () => useContext(ChartSeriesActionContext);

ChartSeriesActionContext['displayName'] = 'ChartSeriesActionContext';
